import { Button, Form, Select } from 'antd';
import * as React from 'react';
import { SelectWhenScroll } from '../../common/components/SelectWhenScroll';
import { getIncludedBlockTypes, RULE_BLOCK_TYPES } from '../misc/RuleBlockTypes';

type Props = {
    excludedBlockTypes: string[];
};

type SelectProps = Props & {
    id?: string;
    value?: string[] | null;
    onChange?: (value: string[]) => void;
};

const IncludedBlockTypesSelect: React.FC<SelectProps> = ({ excludedBlockTypes, id, value, onChange }) => {
    const selected = getIncludedBlockTypes(value, excludedBlockTypes);
    const options = [
        ...RULE_BLOCK_TYPES,
        ...selected
            .filter(type => !RULE_BLOCK_TYPES.some(option => option.value === type))
            .map(type => ({ value: type, label: type }))
    ];

    return (
        <>
            <SelectWhenScroll
                id={id}
                mode="multiple"
                value={selected}
                onChange={onChange}
                allowClear
                placeholder="No block types selected"
                style={{ width: '100%' }}
            >
                {options.map(type => (
                    <Select.Option key={type.value} value={type.value}>
                        {type.label}
                    </Select.Option>
                ))}
            </SelectWhenScroll>
            <Button type="link" size="small" onClick={() => onChange?.(RULE_BLOCK_TYPES.map(type => type.value))}>
                Select all
            </Button>
            {value == null && selected.length === 0 && (
                <Button type="link" size="small" onClick={() => onChange?.([])}>
                    Clear
                </Button>
            )}
        </>
    );
};

export const BlockTypesDropdown: React.FC<Props> = ({ excludedBlockTypes }) => (
    <Form.Item label="Include block types" name="includedBlockTypes" data-id="rule-block-types-input">
        <IncludedBlockTypesSelect excludedBlockTypes={excludedBlockTypes} />
    </Form.Item>
);
